module.exports = __webpack_public_path__ + "img/search-zoom-in.1e100bbd.svg";